import * as firebase from 'firebase/app';
import 'firebase/remote-config';
import { APP_ENV } from '@config';

const firebaseConfig = {
	apiKey            : 'AIzaSyDVw7wMvUn3_DtlMo0_9z-5lVPOpSkx9Rw',
	authDomain        : 'rollkall-195020.firebaseapp.com',
	projectId         : 'rollkall-195020',
	messagingSenderId : '807465869556',
	appId             : '1:807465869556:web:c613c4c339821bfa69bea1',
	measurementId     : 'G-FJ0CVZW6RJ',
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

// Remote config setup
const remoteConfig = firebase.remoteConfig(firebaseApp);
// One hour cache time for remote values
remoteConfig.settings.minimumFetchIntervalMillis = 3600000;
remoteConfig.defaultConfig = {
	/* eslint-disable camelcase */
	client_portal_azure_adb2c_enabled : false,
	/* eslint-enable camelcase */
};

/** Returns the value of a specified configuration key
 * @param {String} key The name of the parameter to retrieve a value for
 * @param {'bool'|'string'|'num'} dataType Optional parameter specifying the data type to return the value as
 * @returns The value for the given key
*/
const getConfigValue = async (key, dataType) => {
	if (typeof key !== 'string') throw new Error('Key must be an string');

	/* To prevent reading undefined values, check to see if a default value is defined for the given key */
	if (typeof remoteConfig.defaultConfig[key] === 'undefined') {
		throw new Error(`Remote config value for \`${key}\` doesn't have a local default value.`);
	}

	try {
		await remoteConfig.fetchAndActivate();

		switch (dataType) {
			case 'bool':
				return remoteConfig.getBoolean(key);
			case 'string':
				return remoteConfig.getString(key);
			case 'num':
				return remoteConfig.getNumber(key);
			default:
				return remoteConfig.getValue(key);
		}
	} catch (e) {
		throw new Error('Error fetching remote config');
	}
};

// Get specific enviroment feature flag of key
const getEnvironmentFeatureFlag = async (key) => {
	const flagKey = `${key}_${APP_ENV}`;

	if (remoteConfig.defaultConfig[flagKey] === undefined) {
		remoteConfig.defaultConfig[flagKey] = remoteConfig.defaultConfig[key];
	}

	return getConfigValue(flagKey);
};

export default {
	getConfigValue,
	getEnvironmentFeatureFlag,
};
